import { render } from "./np-radios.vue?vue&type=template&id=3984d9bc"
import script from "./np-radios.vue?vue&type=script&lang=js"
export * from "./np-radios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__